import React from 'react';
import { Box, Grid, Typography } from '@mui/material';

const ProjectSummary = ({ project }) => {

  return (
    <Box className="summary-grid-table" sx={{ px: 2, py: 2 }}>
      <Grid
        container
        direction="row"
        justifyContent="flex-start"
        alignItems="center"
        sx={{ py: 1, borderBottom: 1, borderColor: 'divider', }}
      >
        <Grid item xs={1} align="center">
          <Typography variant="subtitle2" component="div" >
            프로젝트 타입
          </Typography>
        </Grid>
        <Grid item xs={3} align="center">
          <Typography variant="subtitle2" component="div" >
            프로젝트 번호
          </Typography>
        </Grid>
        <Grid item xs={3} align="center">
          <Typography variant="subtitle2" component="div" >
            고객명
          </Typography>
        </Grid>
        <Grid item xs={3} align="center">
          <Typography variant="subtitle2" component="div" >
            매출(수금)예정일
          </Typography>
        </Grid>
        <Grid item xs={2} align="center">
          <Typography variant="subtitle2" component="div" >
            예상 금액
          </Typography>
        </Grid>
      </Grid>
      <Grid
        container
        direction="row"
        justifyContent="flex-start"
        alignItems="center"
        sx={{ py: 1, borderBottom: 1, borderColor: 'divider', }}
      >
        <Grid item xs={1} align="center">
          <Typography variant="body2" component="div" >
            {project?.prjTyp === 'N' && '일반'}
            {project?.prjTyp === 'M' && '유지보수'}
          </Typography>
        </Grid>
        <Grid item xs={3} align="center">
          <Typography variant="body2" component="div" >
            {project?.prjNo}
          </Typography>
        </Grid>
        <Grid item xs={3} align="center">
          <Typography variant="body2" component="div" >
            {project?.partnerInc}
          </Typography>
        </Grid>
        <Grid item xs={3} align="center">
          <Typography variant="body2" component="div" >
            {(project?.expDay) ? (project?.expDay) : `-`}
          </Typography>
        </Grid>
        <Grid item xs={2} align="center">
          <Typography variant="body2" component="div" >
            {(project?.expSales) ? (`₩ ${project?.expSales.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`) : `-`}
          </Typography>
        </Grid>
      </Grid>
    </Box>
  );
};

export default ProjectSummary;
